




















import { Component, Prop, Vue } from 'vue-property-decorator';

export interface PanelActionButtonItemType {
  title: string;
  event: string;
}

@Component
export default class PanelActionButton extends Vue {
  @Prop()
  private items!: PanelActionButtonItemType[];

  private clickButton() {}

  private clickAction(target: string) {
    this.$emit(target);
  }
}
